import { createSelector } from 'reselect';
import { ROOM_TYPES } from './constants';
import { orderBy } from 'lodash';
import { getPersonnelRolesMapper } from 'shared/helpers';
const getRoomTypes = state => state.statics.roomTypes;
const getRoom = state => state.roomOptions.room;
const getRoles = state => state.statics.roles;

const getSingleRoomFlag = createSelector(
  [getRoom],
  (room) => {
    if (room && room.id) {
      return room.singleRoomFlag;
    }
    return false;
  }
);

export const mapRoomTypesById = createSelector(
  [getRoomTypes],
  (roomTypes) => {
    let mappedTypes = {};
    roomTypes.forEach(type =>
      mappedTypes[type.id] = type
    );
    return mappedTypes;
  }
);

export const mapRoomTypeOptions = createSelector(
  [getRoomTypes, getSingleRoomFlag],
  (roomTypes, singleRoomFlag) => {
    const typeOnlineOptions = [];
    const typePaperOptions = [];
    if (roomTypes.length) {
      orderBy(roomTypes,['displayOrder'],['asc']).forEach((type) => {
        if (type.onlineFlag) {
          typeOnlineOptions.push({
            label: type.name,
            key: `roomType-${type.id}`,
            value: type.id,
            name: 'roomType',
          });
        } else {
          typePaperOptions.push({
            label: type.name,
            key: `roomType-${type.id}`,
            value: type.id,
            disabled: type.name.includes(ROOM_TYPES.combination) ? singleRoomFlag : false,
            name: 'roomType',
          });
        }

      });
    }
    return {
      online: typeOnlineOptions,
      paper: typePaperOptions,
    };
  }
);

export const getOrderedRoomTypes = createSelector(
  [getRoomTypes],
  (roomTypes) =>
    orderBy(roomTypes, ['displayOrder'])
);

export const getPersonnelRoles = createSelector(
  [getRoles], 
  (roles) => getPersonnelRolesMapper(roles)

)